import { ReactNode } from 'react';

import { Container, Headings, Line, Text } from '@foradevelopment/fora-ui';

export const EmploymentFormStepWrapper = ({
  heading,
  ingress,
  isFirstStep = false,
  disabled = false,
  noPadding = false,
  children,
}: {
  heading?: string;
  ingress?: string;
  isFirstStep?: boolean;
  disabled?: boolean;
  noPadding?: boolean;
  children: ReactNode;
}) => (
  <Container paddingBottom={noPadding ? 0 : 60}>
    {!isFirstStep && <Line marginBottom={60} color="black10" />}
    {heading && (
      <Headings.H5 marginBottom={ingress ? 6 : 30} color={disabled ? 'black50' : undefined}>
        {heading}
      </Headings.H5>
    )}
    {ingress && <Text marginBottom={30}>{ingress}</Text>}
    {children}
  </Container>
);
